import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlameArrestor = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 40,
	viewBox: "0 0 100.0 40.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 20.0 0.0 L 80.0 0.0 L 88.5 20.0 L 80.0 40.0 L 20.0 40.0 L 11.5 20.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 10.0 L 0.0 30.0 M 3.0 10.0 L 3.0 30.0 M 3.0 20.0 L 11.5 20.0 M 100.0 10.0 L 100.0 30.0 M 97.0 10.0 L 97.0 30.0 M 97.0 20.0 L 88.5 20.0 M 20.0 0.0 L 20.0 40.0 M 30.0 0.0 L 30.0 40.0 M 40.0 0.0 L 40.0 40.0 M 50.0 0.0 L 50.0 40.0 M 60.0 0.0 L 60.0 40.0 M 70.0 0.0 L 70.0 40.0 M 80.0 0.0 L 80.0 40.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgFlameArrestor;
